import { render, staticRenderFns } from "./Case.vue?vue&type=template&id=2b4c675a&lang=true"
import script from "./Case.vue?vue&type=script&lang=js"
export * from "./Case.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports